export default class LoadScriptFilesService{
  head_script(src,id,fetchpriority = '',type = 'text/javascript') {
    return new Promise((resolve, reject) => {
      if(document.querySelector("script[src='" + src + "']")){ resolve(true); }
      let script = document.createElement('script');
      script.setAttribute('src', src);
      if(type){
        script.setAttribute('type', type);
      }
      if(fetchpriority){
        script.setAttribute('fetchpriority', fetchpriority);
      }
      if(id){
        script.setAttribute('id', id);
      }
      script.onload = () => resolve();
      script.onerror = () => reject();
      document.head.appendChild(script)
    });
  }


  del_script(src) {
    let el = document.querySelector("script[src='" + src + "']");
    if(el){ el.remove(); }
  }


  head_link(href) {
    return new Promise((resolve, reject) => {
      if(document.querySelector("link[href='" + href + "']")){ resolve(true); }
      let link = document.createElement('link');
      link.setAttribute('href', href);
      link.setAttribute('rel', "stylesheet");
      link.setAttribute('type', "text/css");
      link.onload = () => resolve();
      link.onerror = () => reject();
      document.head.appendChild(link)
    });

  }


  del_link(href) {
    let el = document.querySelector("link[href='" + href + "']");
    if(el){ el.remove(); }
  }


}



// WEBPACK FOOTER //
// ./src/services/LoadScriptFilesService.js